
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 -1 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.655 4.827l-.633-1.819-.632 1.819A2.674 2.674 0 014.92 6.622l-1.925.04 1.534 1.163a2.674 2.674 0 01.944 2.905l-.557 1.843 1.58-1.1a2.674 2.674 0 013.055 0l1.58 1.1-.557-1.843a2.674 2.674 0 01.944-2.905l1.534-1.163-1.925-.04a2.674 2.674 0 01-2.471-1.795zm.63-2.258c-.416-1.197-2.11-1.197-2.525 0l-.633 1.819a1.337 1.337 0 01-1.235.898l-1.925.039c-1.267.026-1.79 1.636-.78 2.402L3.72 8.89c.445.338.633.918.472 1.453l-.558 1.843c-.367 1.213 1.003 2.208 2.044 1.484l1.58-1.1a1.337 1.337 0 011.527 0l1.58 1.1c1.04.724 2.41-.271 2.044-1.485l-.558-1.842a1.337 1.337 0 01.472-1.453l1.534-1.163c1.01-.766.487-2.376-.78-2.402l-1.925-.04a1.337 1.337 0 01-1.236-.897l-.632-1.819z","fill":"currentColor"}})])
          )
        }
      }
    